export const createColumns = ({
    toDetail,
    editDetail,
    deleteAction
}) => [{
        title: '产品编码',
        key: 'skuCode',
        render: (h, p) => {
            return h('div', [
                h('a', {
                    on: {
                        click: () => {
                            toDetail(p)
                        },
                    }
                }, p.row.skuCode)
            ])
        }
    }, {
        title: '产品名称',
        key: 'skuName',
    }, {
        title: '批次号',
        key: 'pici',
    }, {
        title: '附件名称',
        key: 'fujianAddr',
        render: (h, p) => {
            return h('a', {
                on: {
                    click: () => {
                        window.open("/api/CusFahuo/downloadFahuo?fileName=" + p.row.fujianAddr+"&id="+p.row.id)
                    }
                }
            }, p.row.fujianAddr)
        }
    }
    // }, {
    //     title: '操作',
    //     render: (h, p) => {
    //         return h('div', [
    //             h('a', {
    //                 on: {
    //                     click: () => {
    //                         editDetail(p)
    //                     }
    //                 }
    //             }, '编辑'),
    //             h('a', {
    //                 style: {
    //                     marginLeft: '10px',
    //                     color: 'red'
    //                 },
    //                 on: {
    //                     click: () => {
    //                         deleteAction(p)
    //                     }
    //                 }
    //             }, '删除')
    //         ])
    //     }
    // }
]